import React from "react"
import Label from "./Label"
import styles from "./Checkbox.module.css"
import IconWithExplanation from "../icons/IconWithExplanation"

const Checkbox = ({ label, onChange, disabled, id, value, disabledExplanation }) => {
  return (
    <div className={styles.wrapper}>
      <input
        type="checkbox"
        id={id}
        data-testid="input"
        disabled={disabled}
        checked={value}
        className={styles.input}
        onChange={(e) => onChange(!value)}
      />
      <Label className={styles.label} id={id}>
        {label}
      </Label>
      {disabled && disabledExplanation && (
        <IconWithExplanation icon="exclamation-circle" explanation={disabledExplanation} />
      )}
    </div>
  )
}

Checkbox.defaultProps = {
  onChange: () => {},
  disabled: false,
}

export default Checkbox
